import { ItemRecord } from "@controladad/ng-base";
import {  BannerStatus, BannerTarget, BannerType, BlogStatus } from "@models";

export const BannerStatusValues: ItemRecord<BannerStatus>[] = [
  { value: 1, label: 'Enabled' },
  { value: 0, label: 'Disabled' },
];
export const BannerEnableValues: ItemRecord<boolean>[] = [
  { value: true, label: 'Enabled' },
  { value: false, label: 'Disabled' },
];


export const BannerTargetValues: ItemRecord<BannerTarget>[] = [
  { value: 0, label: 'App' },
  { value: 1, label: 'Website' },
];

export const BlogStatusValues: ItemRecord<BlogStatus>[] = [
  { value: 1, label: 'Enabled' },
  { value: 0, label: 'Disabled' },
];


export const BannerTypeValues: ItemRecord<BannerType>[] = [
  { value: 2, label: 'Brand' },
  { value: 1, label: 'Category' },
  { value: 0, label: 'Product' },
  { value: 3, label: 'Rail' },
];
